import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";

import { TOGGLE, PULSE, ON, OFF, COMMANDS } from "../../../shared";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/linq8acm/flags/get";
  export const REQUEST_POST = "io/request/linq8acm/flags/post";
  export const RESPONSE_GET = "io/response/linq8acm/flags/get";
  export const RESPONSE_POST = "io/response/linq8acm/flags/post";
  export const EDIT = "io/edit/linq8acm/flags";
  export const POLL_START = "io/poll/linq8acm/outputs/start";
  export const POLL_STOP = "io/poll/linq8acm/outputs/stop";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
    exe?: { idx: number; cmd: COMMANDS };
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface Edit extends TAction<typeof EDIT> {
    data: Partial<State.Data>;
  }
  export interface PollStart extends TAction<typeof POLL_START> {}
  export interface PollStop extends TAction<typeof POLL_STOP> {}
  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const edit = actionCreator<Edit>(EDIT);
  export const pollStart = actionCreator<PollStart>(POLL_START);
  export const pollStop = actionCreator<PollStop>(POLL_STOP);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }
  export const exe = (idx: number, cmd: COMMANDS) =>
    postRequest({ data: {}, exe: { idx: idx, cmd: cmd } });
  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      edit: (data: Partial<State.Data>) => dispatch(edit({ data })),
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest()),
      poll: (p: boolean) =>
        dispatch(p ? pollStart({ data: p }) : pollStop({ data: p })),
      calZeros: () => dispatch(fetchRequest({ calZeros: 1 })),
      turnOn: (idx: number) => dispatch(exe(idx, ON)),
      turnOff: (idx: number) => dispatch(exe(idx, OFF)),
      toggle: (idx: number) => dispatch(exe(idx, TOGGLE)),
      pulse: (idx: number) => dispatch(exe(idx, PULSE)),
      exe: (idx: number, cmd: COMMANDS) => dispatch(exe(idx, cmd))
    };
  };
}
